import icon from "images/icons/icon-open_new-white.svg?raw"
import parse from "html-react-parser"

export default function OpenNewTabIcon({ title }) {
  return (
    <span className="svg-icon" title={title}>
      {parse(icon)}
    </span>
  )
}
